import React, { useState } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { AppLayout } from './components/layout/AppLayout';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { MyPlotsPage } from './pages/MyPlotsPage';
import { PlotDetailsPage } from './pages/PlotDetailsPage';
import { LandRecordDetailsPage } from './pages/LandRecordDetailsPage';
import { CLOCertificatePage } from './pages/CLOCertificatePage';
import { MapViewPage } from './pages/MapViewPage';
import { ReportsPage } from './pages/ReportsPage';
import { CLOVerificationPage } from './pages/CLOVerificationPage';
import { MouzaMapPage } from './pages/MouzaMapPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { CreateRecordPage } from './pages/CreateRecordPage';
const PlaceholderPage = ({
  title
}: {
  title: string;
}) => <div className="flex items-center justify-center h-64 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-0">
    <h2 className="text-2xl font-bold text-gray-400" data-id="element-1">{title} Page Content</h2>
  </div>;
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedPlotId, setSelectedPlotId] = useState<string | null>(null);
  // Mouza filter state lifted to App level so it persists across navigation
  const [mouzaFilterState, setMouzaFilterState] = useState({
    selectedDistrict: '',
    selectedUpazila: '',
    selectedMouza: ''
  });
  const navigateTo = (page: string) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage navigateTo={navigateTo} data-id="element-2" />;
      case 'login':
        return <LoginPage navigateTo={navigateTo} data-id="element-3" />;
      case 'dashboard':
        return <DashboardPage navigateTo={navigateTo} setSelectedPlotId={setSelectedPlotId} data-id="element-4" />;
      case 'myPlots':
        return <MyPlotsPage navigateTo={navigateTo} setSelectedPlotId={setSelectedPlotId} data-id="element-5" />;
      case 'plotDetails':
        return <PlotDetailsPage plotId={selectedPlotId} navigateTo={navigateTo} data-id="element-6" />;
      case 'landRecordDetails':
        return <LandRecordDetailsPage plotId={selectedPlotId} navigateTo={navigateTo} data-id="element-7" />;
      case 'cloCertificate':
        return <CLOCertificatePage plotId={selectedPlotId} navigateTo={navigateTo} data-id="element-8" />;
      case 'mouzaMap':
        return <MouzaMapPage navigateTo={navigateTo} setSelectedPlotId={setSelectedPlotId} filterState={mouzaFilterState} setFilterState={setMouzaFilterState} data-id="element-9" />;
      case 'map':
        return <MapViewPage navigateTo={navigateTo} setSelectedPlotId={setSelectedPlotId} data-id="element-10" />;
      case 'reports':
        return <ReportsPage data-id="element-11" />;
      case 'cloVerification':
        return <CLOVerificationPage navigateTo={navigateTo} data-id="element-12" />;
      case 'search':
        return <PlaceholderPage title="Search" data-id="element-13" />;
      case 'services':
        return <PlaceholderPage title="Services" data-id="element-14" />;
      case 'notifications':
        return <NotificationsPage navigateTo={navigateTo} setSelectedPlotId={setSelectedPlotId} data-id="element-15" />;
      case 'profile':
        return <PlaceholderPage title="Profile" data-id="element-16" />;
      case 'createRecord':
        return <CreateRecordPage navigateTo={navigateTo} data-id="element-17" />;
      default:
        return <DashboardPage navigateTo={navigateTo} setSelectedPlotId={setSelectedPlotId} data-id="element-18" />;
    }
  };
  return <LanguageProvider data-id="element-19">
      <AppLayout currentPage={currentPage} navigateTo={navigateTo} data-id="element-20">
        {renderPage()}
      </AppLayout>
    </LanguageProvider>;
}